import styled from "@emotion/styled";
import { ThemeMode } from "../../../../util/theme";
import { menuTheme } from "../../../menu/styled/menuTheme";
import { TypeRampV2 } from "../../../typography";

interface SelectedOptionFacadeProps {
    themeMode: ThemeMode;
    isContentBeforeVisible?: boolean;
}

export const SelectedOptionFacade = styled(TypeRampV2)<SelectedOptionFacadeProps>`
    position: absolute;
    // very specifically match the position of the input.
    top: 11px;
    left: ${({ isContentBeforeVisible }) => (isContentBeforeVisible ? "40px" : "12px")};
    font-size: ${({ themeMode }) => menuTheme.fontSize(themeMode)};
    line-height: 18px;
    min-width: 0;
    overflow-wrap: break-word;
    /**
    * Since wrapper is absolute positioned, it ignores the initial max width coming from
    * parent after setting text overflow and white-space properties, by setting width
    * to 100% it takes all the available space (including the slot for buttons) so
    * we need to subtract the slot width, nonetheles, the ellipsis is still being overflowed
    * so, by adding a 72px substract, it behaves the same as select basic. The value of 100px
    * is to account for it being pushed to the right by content before.
    */
    max-width: ${({ isContentBeforeVisible }) => (isContentBeforeVisible ? "calc(100% - 100px)" : "calc(100% - 72px)")};
`;
